import React from 'react';
import { FilterSettings } from '@yme/assets/icons';
import { useTranslation } from '@yme/services/i18n';
import { FiltersButtonStyled } from './styled';
export function MobileFiltersButton({ label = '', onClick }) {
    const { t } = useTranslation();
    return (React.createElement(FiltersButtonStyled, { isFirstIcon: true, iconType: FilterSettings, onClick: onClick }, label || t('filters_filters_label')));
}
